import { useMemo } from 'react'
import { type Workflow, type AccountData, isNotDefined } from '@terros/common'
import { useProfile } from '../../user'
import { buildAccountTimeline } from './workflowTimeline'
import { getHistoryCutoffDate } from './getHistoryCutoffDate'

type UseAccountTimelineProps = {
  workflow: Workflow
  account: AccountData
}

export const useAccountTimeline = ({
  workflow,
  account,
}: UseAccountTimelineProps): ReturnType<typeof buildAccountTimeline> => {
  const { user } = useProfile()
  return useMemo(() => {
    if (isNotDefined(user)) return []
    const cutoffDate = getHistoryCutoffDate({ workflow, account, user })
    return buildAccountTimeline({ workflow, account, cutoffDate })
  }, [workflow, account, user])
}
